import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 pt-16 md:pt-20 pb-8">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 mb-12">
            {/* Brand */}
            <div className="lg:col-span-4">
              <Link
                to="/"
                className="inline-block font-heading font-black text-2xl text-foreground-950 mb-4"
              >
                53<span className="text-primary-500">吃瓜</span>
              </Link>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-xs">
                53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。专注娱乐八卦，真实爆料全网追踪。
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  rel="nofollow noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors"
                  aria-label="微博"
                >
                  <i className="ri-weibo-fill text-sm" />
                </a>
                <a
                  href="#"
                  rel="nofollow noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors"
                  aria-label="微信"
                >
                  <i className="ri-wechat-fill text-sm" />
                </a>
                <a
                  href="#"
                  rel="nofollow noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-fill text-sm" />
                </a>
              </div>
            </div>

            {/* Category Links */}
            <div className="lg:col-span-2 lg:col-start-6">
              <h4 className="font-heading font-bold text-foreground-950 text-sm uppercase tracking-wider mb-4">
                热门分类
              </h4>
              <ul className="space-y-3">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-2">
              <h4 className="font-heading font-bold text-foreground-950 text-sm uppercase tracking-wider mb-4">
                快速导航
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/"
                    className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    rel="nofollow"
                    className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                  >
                    投稿爆料
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    rel="nofollow"
                    className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                  >
                    商务合作
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="lg:col-span-3">
              <h4 className="font-heading font-bold text-foreground-950 text-sm uppercase tracking-wider mb-4">
                联系方式
              </h4>
              <ul className="space-y-3">
                <li className="text-foreground-600 text-sm">
                  <span className="text-foreground-400 mr-2">邮箱:</span>
                  hello@ihthrnq.com
                </li>
                <li className="text-foreground-600 text-sm">
                  <span className="text-foreground-400 mr-2">商务:</span>
                  hello@ihthrnq.com
                </li>
                <li className="text-foreground-600 text-sm">
                  <span className="text-foreground-400 mr-2">爆料:</span>
                  hello@ihthrnq.com
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-background-200 pt-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; 2026 53吃瓜网 版权所有 | 本站内容仅供娱乐参考
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors">
                  免责声明
                </a>
                <span className="text-foreground-300">|</span>
                <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors">
                  隐私政策
                </a>
                <span className="text-foreground-300">|</span>
                <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors">
                  用户协议
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}